import { formatCompactNumber } from 'helpers/DataHelper';
import { NumericFormat } from 'react-number-format';

function NumberFormatLabelElement({
  amount,
  decimalNumber,
  prefix,
  suffix,
  className,
  showDecimal = true,
  prefixSpacing = false,
  suffixSpacing = false,
  isCompact = false,
  compact = false,
  uppercaseCompact = false,
}: {
  amount: string | number;
  decimalNumber?: number;
  prefix?: string | number;
  suffix?: string | number;
  className?: string;
  showDecimal?: boolean;
  prefixSpacing?: boolean;
  suffixSpacing?: boolean;
  isCompact?: boolean;
  compact?: boolean;
  uppercaseCompact?: boolean;
}) {
  const useCompact = isCompact || compact;
  const numAmount = typeof amount === 'number' ? amount : Number(amount || 0);

  if (useCompact && !isNaN(numAmount)) {
    const compactStr = formatCompactNumber(numAmount, uppercaseCompact);
    const prefixText = prefix ? (prefixSpacing ? prefix + ' ' : String(prefix)) : '';
    const suffixText = suffix ? (suffixSpacing ? ' ' + suffix : String(suffix)) : '';
    return (
      <span className={`num-format ${className ? className : ''}`}>
        {prefixText}
        {compactStr}
        {suffixText}
      </span>
    );
  }

  const decimalScale = decimalNumber ? decimalNumber : 2;
  const prefixText = prefix ? (prefixSpacing ? prefix + ' ' : String(prefix)) : '';
  const suffixText = suffix ? (suffixSpacing ? ' ' + suffix : String(suffix)) : '';
  return (
    <NumericFormat
      className={`num-format ${className ? className : ''}`}
      prefix={prefixText}
      suffix={suffixText}
      value={amount}
      displayType="text"
      thousandSeparator={true}
      decimalScale={showDecimal ? decimalScale : 0}
      fixedDecimalScale={true}
      thousandsGroupStyle="lakh"
      /* thousandsGroupStyle={Country.code === INDIA_COUNTRY_CODE ? 'lakh' : 'none'} */
    />
  );
}

export default NumberFormatLabelElement;
